import React, { useState } from "react";
import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
import UsersListTable from "./UsersListTable";
import { CustomButton, EmptyState, icon, SearchInput } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { searchInString } from "../../../../common/utils";
import styles from "./UsersList.module.css";

function filterUsers(user, search) {
	return (
		searchInString(user?.firstName, search) ||
		searchInString(user?.lastName, search) ||
		searchInString(user?.displayName, search) ||
		searchInString(user?.email, search)
	);
}

export default function UsersList({
	companyId,
	isAdding,
	onSetIsAdding,
	users = [],
	onChangeLock,
	onChangeRole,
	COMPANY_ROLES = [],
}) {
	const [search, setSearch] = useState("");
	const loggedUser = useSelector(({ context }) => context.user);
	const filteredUsers = users.filter((user) => filterUsers(user, search));
	return (
		<>
			<div className={styles.header}>
				<SearchInput
					className={styles.searchInput}
					placeholder={translate("admin.user-list.search-label")}
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					onClearSearch={() => setSearch("")}
				/>
				<CustomButton
					className={styles.addButton}
					color="primary"
					data-testid="add.user.button"
					size="md"
					startIcon={icon.faPlus}
					variant="contained"
					onClick={() => onSetIsAdding(!isAdding)}
				>
					{translate("admin.user-list.add-user.button")}
				</CustomButton>
			</div>
			<Alert className={styles.alert} severity="info">
				{translate("admin.user-list.info-banner")}
			</Alert>
			{filteredUsers.length === 0 && search ? (
				<EmptyState
					btn1={
						<CustomButton
							color="primary"
							size="md"
							startIcon={icon.faPlus}
							variant="contained"
							onClick={() => onSetIsAdding(true)}
						>
							{translate("admin.user-list.add-user.button")}
						</CustomButton>
					}
					content={translate("admin.user-list.empty-state.no-result", { search })}
					title={translate("admin.user-list.empty-state.title")}
				/>
			) : (
				<UsersListTable
					COMPANY_ROLES={COMPANY_ROLES}
					companyId={companyId}
					loggedUser={loggedUser}
					users={filteredUsers}
					onChangeLock={onChangeLock}
					onChangeRole={onChangeRole}
				/>
			)}
		</>
	);
}
